export default function WarningIcon() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.97956 20C3.88628 20 3 19.1137 3 18.0204C3 17.5571 3.10843 17.1002 3.31661 16.6863L9.39123 4.60807C9.88709 3.62215 10.8964 3 12 3C13.1036 3 14.1129 3.62215 14.6088 4.60807L20.6834 16.6863C20.8916 17.1002 21 17.5571 21 18.0204C21 19.1137 20.1137 20 19.0204 20H4.97956Z"
        fill="#E6A400"
      />
      <path d="M12 9V13" stroke="white" strokeWidth="2" strokeLinecap="round" />
      <circle cx="12" cy="17" r="1" fill="white" />
    </svg>
  );
}
